var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00096 0.668335C4.39929 0.668335 0.668457 4.39917 0.668457 9.00084C0.668457 13.1592 3.71512 16.6058 7.69929 17.2333V11.41H5.58262V9.00084H7.69929V7.165C7.69929 5.075 8.94346 3.9225 10.846 3.9225C11.7576 3.9225 12.7126 4.085 12.7126 4.085V6.13417H11.6593C10.626 6.13417 10.3026 6.7775 10.3026 7.43667V8.99917H12.6118L12.2426 11.4083H10.3026V17.2317C14.2868 16.6075 17.3335 13.16 17.3335 9.00084C17.3335 4.39917 13.6026 0.668335 9.00096 0.668335Z",
    fill: "#3B5999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.41684e49.svg";
export { ForwardRef as ReactComponent };